import { useState, useEffect } from 'react';
import useActiveEmployeeId from './useActiveEmployeeId';
import EmployeeService from '../services/EmployeeService';
import type { Employee } from '@frontend/Models/Employee/EmployeeModels';

interface CurrentEmployee extends Employee {
  isLoading: boolean;
}

const useCurrentEmployee = (): CurrentEmployee | null => {
  const employeeId = useActiveEmployeeId();
  const [employee, setEmployee] = useState<CurrentEmployee | null>(null);

  useEffect(() => {
    if (!employeeId) {
      setEmployee(null);
      return;
    }

    let isMounted = true;

    const fetchEmployee = async () => {
      try {
        const data = await EmployeeService.getEmployeeById(employeeId);
        if (isMounted && data) {
          setEmployee({
            ...data,
            isLoading: false,
          });
        }
      } catch (error) {
        console.error('Error fetching current employee:', error);
        if (isMounted) {
          setEmployee(null);
        }
      }
    };

    setEmployee((prev) => prev ? { ...prev, isLoading: true } : null);
    fetchEmployee();

    return () => {
      isMounted = false;
    };
  }, [employeeId]);

  return employee;
};

export default useCurrentEmployee;
